<template>
  <div>
    <b-modal
        id="modal_itens"
        title="Itens do Pedido"
        size="xl"
        ok-title="Salvar"
        cancel-title="Cancelar"
        cancel-variant="outline-secondary"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
    >
      <b-card
          no-body
          class="mb-0"
      >
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col
                cols="12"
                md="6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Mostrar</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>entradas</label>
            </b-col>

            <b-col
                cols="12"
                md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Pesquisar..."
                />
                <!--              <b-button-->
                <!--                  variant="primary"-->
                <!--                  v-b-modal.modal-add-item-->
                <!--                  @click="resetFormData"-->
                <!--              >-->
                <!--                <div class="d-flex" style="gap: 5px">-->
                <!--                  <iconfy icon="mdi:plus"/>-->
                <!--                  <span class="">Item</span>-->
                <!--                </div>-->
                <!--              </b-button>-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
            ref="refItemListTable"
            class="position-relative"
            :items="fetchItem"
            responsive
            :fields="tableColumns"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="Nenhum registro encontrado"
            :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(actions)="data">
            <div>
              <b-button
                  variant="gradient-primary"
                  class="btn-icon"
                  @click="showModalEscolherQuantidadePreco(data.item)"
              >
                            Selecionar
                          </b-button>
            </div>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                dataMeta.of
              }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItem"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-modal
          id="modal_item_escolhido"
          title="Item do Pedido"
          size="md"
          ok-title="Adicionar Item ao Pedido"
          cancel-title="Cancelar"
          cancel-variant="outline-secondary"
          @show="resetModal"
          @hidden="resetModal"
          @ok="adicionarItemAoPedido"
      >
          <b-form @submit.prevent>
            <b-form-group
                label="Quantidade:"
                label-for="quantidade-input"
            >
              <b-form-input
                  id="quantidade-input"
                  v-model="quantidade"
                  type="number"
                  required
                  placeholder="Digite a quantidade"
              ></b-form-input>
            </b-form-group>

            <b-form-group
                label="Preço:"
                label-for="preco-input"
            >
              <b-form-input
                  id="preco-input"
                  type="number"
                  v-model="valorUnitario"
                  min="0"
                  step="0.01"
                  required
                  placeholder="Digite o preço"
              ></b-form-input>
            </b-form-group>
          </b-form>
      </b-modal>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BFormSelect, BCol, BButton, BTable, BCard, BRow,
} from 'bootstrap-vue';
import { mapActions, mapGetters } from 'vuex';
import ProductionItem from '@/views/app/operacoes/pedidosVendas/swipper/swipperItensProdutos.vue';
import GradePedidos from '@/views/app/operacoes/pedidosVendas/tabelaGrade/gradePedidos.vue';
import useList from '@/views/cadastros-gerais/item/list/useList';
import { avatarText } from '@core/utils/filter';
import SLSitemExService from '@/services/SistemaDKP/SLSitemEx.service';
import { onMounted, ref } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BRow, BCard, BTable, GradePedidos, BButton, BModal, BCol, BFormSelect, ProductionItem,
  },
  data() {
    return {
      valorUnitario: null,
      quantidade: null,
      item: [],
    };
  },
  methods: {
    ...mapActions('intensPedido', [
      'itensMarcaPedido',
      'itensCategoriaPedido',
      'itensReferenciaPedido',
      'itensEmbalagemPedido',
      'setListTabelaItens',
      'itensdetalhes',
    ]),
    show() {
      this.$bvModal.show('modal_itens');
    },
    async adicionarItemAoPedido() {
      // console.log('ITEM ESCOLIDO', this.item)
      // console.log('ITEM',this.item,'QUANTIDADE', this.quantidade,'VALOR', this.valorUnitario)
      this.item.quantidade = this.quantidade;
      this.item.valorUnitario = this.valorUnitario;
      this.item.valorTotal = this.quantidade * this.valorUnitario;
      await this.setListTabelaItens(this.item);
      this.$bvModal.hide('modal_item_escolhido');
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Item adicionado ao pedido com sucesso!',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
    },
    showModalEscolherQuantidadePreco(item) {
      console.log('ITEM ESCOLIDO', item);
      this.item = item;
      this.$bvModal.show('modal_item_escolhido');
    },
    async resetModal() {
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
  },
  setup() {
    const sLSitemExService = new SLSitemExService();
    const customFields = ref([]);
    const dataItem = ref({
      item_id: '',
      item_descricao: '',
      item_peso_bruto: '',
      item_peso_liquido: '',
      item_codigo_origem: '',
    });
    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);
    const refCollapeseCamposPadrao = ref(null);
    const refCollapeseCamposPersonalizados = ref(null);

    const listarCustomFields = async () => {
      customFields.value = await sLSitemExService.index();
    };

    onMounted(async () => {
      await listarCustomFields();
    });
    const toggleCollapseALl = () => {
      spanderAll.value = !spanderAll.value;
      console.log(refCollapeseCamposPadrao.value);
    };
    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      tableColumns,
      refItemListTable,
      fetchItem,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      createOrUpdated,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,

      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      refCollapeseCamposPadrao,
      refCollapeseCamposPersonalizados,
      toggleCollapseALl,
      currentTab,
      dataItem,
      typeOptionsCustomFields,
      listarCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,

      perPage,
      currentPage,
      totalItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchItem,
      tableColumns,
      refItemListTable,
      createOrUpdated,
      removerData,
    };
  },

};

</script>

<style scoped>
.container-images-prod {
  width: 500px;
}
</style>
